import React from "react";
import "./AgendaTasks.css";
import AgendaTaskCard from "./AgendaTaskCard/AgendaTaskCard";
import TasksHeader from "../TasksHeader/TasksHeader";

const AgendaTasks = ({ events = [] }) => {
  let todos = 0;
  let appointments = 0;
  events.forEach((event) => {
    if (event.category === 1) todos++;
    else appointments++;
  });

  return (
    <TasksHeader todos={todos} appointments={appointments} showScroll={false}>
      <div className="agenda-tasks-list">
        {events.map((event) => (
          <AgendaTaskCard event={event} key={event.userTaskId} />
        ))}
      </div>
    </TasksHeader>
  );
};

export default AgendaTasks;
